<template>
  <p
    v-if="productNotification"
    class="t-paragraph-large t-paragraph-large--error u-text-align-center"
  >
    {{ productNotification }}
  </p>
</template>

<script>
import get from "lodash/get";
export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    productNotification() {
      const product = this.product;
      let result = get(product, "metafieldsMap.product_notification.value");
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>